import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import AjaxHandler from '../../commons/ajax/AjaxHandler.js';
import Loading from '../ui/Loading.js';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import moment from 'moment';
import 'moment/min/locales';
import Switch from "react-switch";
import { FormattedMessage } from 'react-intl';
import FormValidation from '../../commons/validation/FormValidation';
import Validator from '../../commons/validation/Validator';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import Security from '../../commons/security/Security.js';

class SedeExternaAbm extends Component {
  constructor(props) {
    super(props);
    this.ajaxHandler = new AjaxHandler();
    this.ajaxHandler.subscribe(this);
    moment.locale('es');
    this.state = {
      redirectTo: null,	
  		props: this.props,
      formData: {
        id: 0,
        nombre: '',
        region: null,
        subregion: null,
        tipo: null,
        activo: true,
      },
      regiones: [],
      subregiones: [],
      tipos: [
        { id: 1, nombre: 'Operativa' },
        { id: 0, nombre: 'No Operativa' }
      ],
      errors: [],
      loading: false,
      completeForm: false,
    };
    this.formValidation = new FormValidation({
      component: this,
      validators: {
        'formData.nombre': (value) => Validator.notEmpty(value),
        'formData.region': (value) => Validator.notEmpty(value),
        'formData.subregion': (value) => Validator.notEmpty(value),
        'formData.tipo': (value) => Validator.notEmpty(value),
      }
    });
  }

  componentWillMount() {
    this.initForm();
  }

  componentDidMount(nextProps, nextState) {
      if(! Security.hasPermission('SEDE_EXTERNA_VER') && ConfigBusiness.get('sedeExterna.habilitado') === 'false') {
           this.setState({
              redirectTo: '/error'
            });
        }
    }

  componentWillUnmount() {
    this.ajaxHandler.unsubscribe();
  }

  initForm() {
    this.setState({ loading: true });
    Promise.all([
      this.ajaxHandler.getJson('/regiones', null),
      this.state.props.action !== 'ADD' ? this.ajaxHandler.getJson('/sede-externa/' + this.state.props.match.params.id) : null,
    ])
      .then(([regiones, sedeExterna]) => {
        let formData = sedeExterna || this.state.formData;
        // Normalizar tipo: si viene como string, buscar el objeto correspondiente en tipos
        if (this.state.props.action == 'EDIT' &&formData && typeof formData.tipo === 'string') {
          const tipoObj = this.state.tipos.find(t => t.nombre.toLowerCase() === formData.tipo.toLowerCase());
          formData = { ...formData, tipo: tipoObj || null };
        }
        // Normalizar activo: si viene como 1/0, convertir a booleano
        if (formData && typeof formData.activo === 'number') {
          formData = { ...formData, activo: formData.activo === 1 };
        }
        this.setState({ regiones, formData });
      })
      .catch((error) => {
        this.exit();
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  handleInputFormChange = (event) => {
    const { name, value, type, checked } = event.target;
    this.setState(prevState => {
      const newFormData = {
        ...prevState.formData,
        [name]: type === 'checkbox' ? checked : value
      };
      const completeForm = !!newFormData.nombre && !!newFormData.region && !!newFormData.subregion && !!newFormData.tipo;
      return {
        formData: newFormData,
        completeForm
      };
    }, () => {
      this.formValidation.validate();
    });
  }

  handleSelectFormChange = (name, object) => {
    let value = object === null ? null : object;
    this.setState(prevState => {
      const newFormData = {
        ...prevState.formData,
        [name]: value
      };
      const completeForm = !!newFormData.nombre && !!newFormData.region && !!newFormData.subregion && !!newFormData.tipo;
      return {
        formData: newFormData,
        completeForm
      };
    }, () => {
      this.formValidation.validate();
    });
  }

  handleRegionChange = async (name, object) => {
    const regionObj = object && this.state.regiones.find(r => r.id === object.id) ? this.state.regiones.find(r => r.id === object.id) : null;
    const newFormData = { ...this.state.formData, region: regionObj, subregion: null };
    const completeForm = !!newFormData.nombre && !!newFormData.region && !!newFormData.subregion && !!newFormData.tipo;
    this.setState({ formData: newFormData, completeForm }, () => {
      this.formValidation.validate();
    });
    if (!regionObj) {
      this.setState({ subregiones: [] });
      return;
    }
    try {
      const subregiones = await this.ajaxHandler.getJson(`/subregiones/${regionObj.id}/select`);
      this.setState({ subregiones: subregiones || [] });
    } catch (error) {
      this.setState({ subregiones: [] });
    }
  }

  handleEstadoChange = (activo) => {
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        activo
      }
    }));
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.formValidation.validate();
    if (!(this.formValidation.state.form && this.formValidation.state.form.valid)) {
      this.setState({ loading: false });
      window.scrollTo(0,0);
      return;
    }
    this.setState({ loading: true });
    this.ajaxHandler.fetch('/sede-externa' + (this.props.action === 'ADD' ? '' : '/' + this.state.formData.id), {
      method: this.props.action === 'ADD' ? 'POST' : 'PUT',
      body: JSON.stringify({ ...this.state.formData }),
    }).then(response => {
      if(response.status !== 400) {
        this.exit();
      } else {
        response.json().then(data => {
          this.setState({ errors: data.detalle });
        });
      }
      window.scrollTo(0,0);
    }).catch((error) => {
      this.ajaxHandler.handleError(error);
    }).finally(() => {
      this.setState({ loading: false });
    });
  }

  handleCancel = () => {
    this.exit();
  }

  exit = () => {
    this.setState({ redirectTo: '/sedesExternas' });
  }

  render() {
    this.formValidation.validate();
    let formData = this.state.formData;
    let validationState = this.formValidation.state;
    return (
      <React.Fragment>
        {this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
        {this.state.loading && <Loading />}
        <div className="row">
          <div className="col-md-12">
            {this.state.errors.length > 0 && (
              <div className="alert alert-danger" role="alert">
                <ul style={{marginBottom:0}}>
                  {this.state.errors.map((e, i) => <li key={i}>{e}</li>)}
                </ul>
              </div>
            )}
            <form className="form form-horizontal" ref="form" onSubmit={this.handleSubmit}>
              <div className="form-body">
                <div className="card pull-up">
                  <div className="card-content">
                    <div className="card-body">
                      <h4 className="form-section">
                        <i className="icon-home"></i> <FormattedMessage id="sedeExternaAbm.datosGenerales" defaultMessage="Datos Generales" /> <div className="float-right" style={{fontSize:'14px'}}>* <FormattedMessage id="sedeExternaAbm.camposRequeridos" defaultMessage="campos requeridos" /></div>
                      </h4>
                      {/* Nombre */}
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="nombre">
                              <FormattedMessage id="sedeExternaAbm.nombre" defaultMessage="Nombre *" />
                            </label>
                            <div className="col-md-9">
                              {(this.state.disableAvlFields || this.props.action === 'VIEW') ? (
                                <div className="form-control-static col-form-label form-value">{formData.nombre}</div>
                              ) : (
                                <React.Fragment>
                                  <input type="text" className={`form-control${validationState.formData && validationState.formData.nombre && !validationState.formData.nombre.valid && !validationState.formData.nombre.pristine ? ' is-invalid' : ''}`} id="nombre" name="nombre" placeholder="Nombre" value={formData.nombre} onChange={this.handleInputFormChange} autoComplete="off" />
                                  <div className="help-block text-danger field-message" hidden={
                                    !validationState.formData ||
                                    !validationState.formData.nombre ||
                                    validationState.formData.nombre.pristine ||
                                    validationState.formData.nombre.valid
                                  }>
                                    {validationState.formData && validationState.formData.nombre && validationState.formData.nombre.message}
                                  </div>
                                </React.Fragment>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Región */}
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="region">
                              <FormattedMessage id="sedeExternaAbm.region" defaultMessage="Región *" />
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' ? (
                                <div className="form-control-static col-form-label">{formData.region ? formData.region.nombre : ''}</div>
                              ) : (
                                <React.Fragment>
                                  <Select
                                    id="region"
                                    name="region"
                                    placeholder="Región"
                                    options={this.state.regiones}
                                    valueKey='id'
                                    labelKey='nombre'
                                    value={formData.region}
                                    onChange={(e) => this.handleRegionChange("region", e)}
                                    className={validationState.formData && validationState.formData.region && !validationState.formData.region.valid && !validationState.formData.region.pristine ? 'is-invalid-select' : ''}
                                  />
                                  <div className="help-block text-danger field-message" hidden={
                                    !validationState.formData ||
                                    !validationState.formData.region ||
                                    validationState.formData.region.pristine ||
                                    validationState.formData.region.valid
                                  }>
                                    {validationState.formData && validationState.formData.region && validationState.formData.region.message}
                                  </div>
                                </React.Fragment>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Subregión */}
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="subregion">
                              <FormattedMessage id="sedeExternaAbm.subregion" defaultMessage="Subregión *" />
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' ? (
                                <div className="form-control-static col-form-label">{formData.subregion ? formData.subregion.nombre : ''}</div>
                              ) : (
                                <React.Fragment>
                                  <Select
                                    id="subregion"
                                    name="subregion"
                                    placeholder="Subregión"
                                    options={this.state.subregiones}
                                    valueKey='id'
                                    labelKey='nombre'
                                    value={formData.subregion}
                                    onChange={(e) => this.handleSelectFormChange("subregion", e)}
                                    className={validationState.formData && validationState.formData.subregion && !validationState.formData.subregion.valid && !validationState.formData.subregion.pristine ? 'is-invalid-select' : ''}
                                  />
                                  <div className="help-block text-danger field-message" hidden={
                                    !validationState.formData ||
                                    !validationState.formData.subregion ||
                                    validationState.formData.subregion.pristine ||
                                    validationState.formData.subregion.valid
                                  }>
                                    {validationState.formData && validationState.formData.subregion && validationState.formData.subregion.message}
                                  </div>
                                </React.Fragment>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Tipo */}
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="tipo">
                              <FormattedMessage id="sedeExternaAbm.tipo" defaultMessage="Tipo *" />
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' ? (
                                <div className="form-control-static col-form-label">{formData.tipo ? (formData.tipo.nombre || formData.tipo) : ''}</div>
                              ) : (
                                <React.Fragment>
                                  <Select
                                    id="tipo"
                                    name="tipo"
                                    placeholder="Tipo"
                                    options={this.state.tipos}
                                    valueKey='id'
                                    labelKey='nombre'
                                    value={formData.tipo}
                                    onChange={(e) => this.handleSelectFormChange("tipo", e)}
                                    className={validationState.formData && validationState.formData.tipo && !validationState.formData.tipo.valid && !validationState.formData.tipo.pristine ? 'is-invalid-select' : ''}
                                  />
                                  <div className="help-block text-danger field-message" hidden={
                                    !validationState.formData ||
                                    !validationState.formData.tipo ||
                                    validationState.formData.tipo.pristine ||
                                    validationState.formData.tipo.valid
                                  }>
                                    {validationState.formData && validationState.formData.tipo && validationState.formData.tipo.message}
                                  </div>
                                </React.Fragment>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* activo */}
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="activo">
                              <FormattedMessage id="sedeExternaAbm.activo" defaultMessage="activo *" />
                            </label>
                            <div className="col-md-9">
                              <Switch
                                onChange={this.handleEstadoChange}
                                checked={formData.activo}
                                id="activo"
                                name="activo"
                                disabled={this.props.action === 'VIEW' ? true : false }
                                offColor="#FF4961"
                                onColor="#28D094"
                              />
                              <div className="help-block text-danger field-message" hidden={
                                !validationState.formData ||
                                !validationState.formData.activo ||
                                validationState.formData.activo.pristine ||
                                validationState.formData.activo.valid
                              }>
                                {validationState.formData && validationState.formData.activo && validationState.formData.activo.message}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body"> 
                    <div className="text-cd text-right">
                      {this.props.action !== 'VIEW' && (
                        <button type="submit" className="btn btn-primary mr-1" disabled={!this.state.completeForm} >
                          <i className="fa fa-check-circle"></i> <FormattedMessage id="sedeExternaAbm.guardar" defaultMessage="Guardar" />
                        </button>
                      )}
                      <button type="button" className="btn btn-danger" onClick={this.handleCancel}>
                        <i className="fa fa-times-circle"></i> {this.props.action === 'VIEW' ? <FormattedMessage id="sedeExternaAbm.volver" defaultMessage="Volver" /> : <FormattedMessage id="sedeExternaAbm.cancelar" defaultMessage="Cancelar" />}
                      </button>
                    </div>
                  </div>
                </div>
              </div> 
            </form>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default SedeExternaAbm;

